import deepmergeFactory from '@fastify/deepmerge';
export const deepmerge = deepmergeFactory();
